import { useMutation } from '@tanstack/react-query';
import { patchStatuses } from '../Services/InvoiceService';

const usePatchInvoicesStatuses = (options = {}) => useMutation(patchStatuses, options);

export default usePatchInvoicesStatuses;
